import React from 'react';
import { FormContainer, FormGroup, FormLabel, FormInput, FormTextArea, FormPrimaryButton, ButtonContainer } from './FormComponents';

interface ManualCreateFormProps {
  title: string;
  description: string;
  onTitleChange: (value: string) => void;
  onDescriptionChange: (value: string) => void;
  onSubmit: () => void;
  isCreating: boolean;
  submitButtonText: string;
}

export const ManualCreateForm = ({
  title,
  description,
  onTitleChange,
  onDescriptionChange,
  onSubmit,
  isCreating,
  submitButtonText
}: ManualCreateFormProps) => {
  const isFormValid = title.trim().length > 0;
  return (
    <>
      <FormContainer>
        <FormGroup>
          <FormLabel required>Title</FormLabel>
          <FormInput 
            value={title} 
            onChange={(e) => onTitleChange(e.target.value)} 
            placeholder="" 
          />
        </FormGroup>

        <FormGroup>
          <FormLabel>Description (optional)</FormLabel>
          <FormTextArea 
            value={description} 
            onChange={(e) => onDescriptionChange(e.target.value)} 
            placeholder="" 
            rows={6} 
          />
        </FormGroup>
      </FormContainer>

      <ButtonContainer>
        <FormPrimaryButton 
          onClick={onSubmit} 
          disabled={!isFormValid || isCreating}
        >
          {isCreating ? 'Creating...' : submitButtonText}
        </FormPrimaryButton>
      </ButtonContainer>
    </>
  );
};